import styled from 'astroturf/react'
import _Marker from "Marker.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_date_time/marker.js?styleId=Marker";

const colorIconSuccess = 'var(--colorIconSuccess, var(--coreColorGreen700))'

const Marker = /*#__PURE__*/styled('div', null, {
  displayName: "Marker",
  styles: _Marker
})

export default Marker
